export default {
  login: { method: 'post', url: '/address/login' }, // 钱包登录
  info: { method: 'get', url: '/address/info' }, // 当前用户信息
  self: { method: 'get', url: '/address/self' }, // 当前用户信息（self）
  index: { method: 'get', url: '/address/index' }, // 用户数据
  bindInviter: { method: 'post', url: '/address/rel/:inviter' }, // 绑定邀请人
  directPage: { method: 'get', url: '/address/direct/page' } // 直推分页
}
